export default __webpack_public_path__ + "static/media/steps__slider-img-1.8dced7a8.png";